import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { stringIsNullOrEmpty } from "../../util/Util";
import ApiEngine from "../../util/ApiEngine";
import Slider from "react-slick";
import { map } from "lodash";
import {
  WebUrl,
  ApiUrl,
  ApiKey,
  LanguageOption,
  SessionKey,
  Language,
  AlertTypes,
  DisplayDevice,
  _MAIN_WALLET_ID,
  PhoneNumberPrefix
} from "../../util/Constant";
import parse from 'react-html-parser';
import AngpaoGif from '../../assets/img/v3/angpao/Angpao_icon.png';
import OpenAngpao from '../../assets/img/v3/angpao/angpao-open.jpg';
import { setAngpaoStatus, setShowAngpaoTnc } from "../../redux/AppAction";
import { useTranslation } from "react-i18next";
import { useHistory, withRouter, useLocation } from "react-router-dom";
import Angpao from '../../pages/home/Angpao';

const AngpaoModal = props => {
  const { isLoggedIn } = useSelector((state) => state.authState);
  const { t, i18n } = useTranslation();
  const _history = useHistory();

  const _dispatch = useDispatch();
  const [angpaoTncContent, setAngpaoTncContent] = useState("");
  const angpaoStatus = useSelector((state) => state.appState.angpaoStatus);
  const showAngpaoTnc = useSelector((state) => state.appState.showAngpaoTnc);
  const [isOpenClaimModal, setIsOpenClaimModal] = useState(false);

  useEffect(() => {
    init();
  }, [angpaoStatus, localStorage.getItem(SessionKey._LANGUAGE)]);

  async function init() {
    if (angpaoStatus) {
      let tncContentResponseJson = await ApiEngine.get(ApiUrl._API_GET_ANGPAO_TNC_CONTENT + "?languageCode=" +
        (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
          localStorage.getItem(SessionKey._LANGUAGE) : 'en'));

      if (tncContentResponseJson[ApiKey._API_SUCCESS_KEY]) {
        let tncContent = tncContentResponseJson[ApiKey._API_DATA_KEY];
        if (!stringIsNullOrEmpty(tncContent)) {
          setAngpaoTncContent(tncContent);
        }

      }
    }
  }

  const closeTncContent = () => {
    _dispatch(setShowAngpaoTnc(false));
  }

  return (
    <div>
      {
        angpaoStatus &&
        <>
          {
            (window.location.pathname === WebUrl._URL_MAIN) &&
            <div className="angpao-container-open" onClick={() => setIsOpenClaimModal(true)}>
              <img
                src={AngpaoGif}
                className="w-100 banner-img-radius"
                alt="banner"
              />
            </div>
          }

          <Modal
            fade={false}
            id="angpao-popup-tnc-modal"
            contentClassName="angpao-popup-tnc-modal-body"
            size="xl"
            isOpen={showAngpaoTnc}
            toggle={() => { closeTncContent(); }}
          >
            <ModalBody className="angpao-tnc-container">
              <div>
                <div>{ t("ANGPAO_TNC")}</div>
                <button
                  type="button"
                  style={{
                    alignSelf: "flex-end",
                    backgroundColor: "transparent",
                    border: "none",
                    fontSize: "1.8rem",
                    color: "#ffffff",
                    padding: "0px",
                    zIndex: 1,
                    position: "relative",
                    float: "right"
                  }}
                  onClick={() => {
                    closeTncContent();
                  }}
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button>
              </div>
              
              <div className="popup-angpao-slider">
                {parse(angpaoTncContent)}
              </div>
            </ModalBody>
          </Modal>
          {isOpenClaimModal &&
            <Modal
              fade={false}
              id="angpao-popup-modal"
              contentClassName="angpao-popup-modal-body"
              size="xl"
              isOpen={isOpenClaimModal}
              toggle={() => { setIsOpenClaimModal(false) }}
            >
              <ModalBody className="angpao-container">
                <Angpao />
              </ModalBody>
            </Modal>

          }
        </>
      }
    </div>
  );
};

export default AngpaoModal;